// Niveau-valget til den automatiske graverapport (ren funktion, ingen THREE/DOM - testet i cutFillAlgorithm.test.js).
//
// Nøjagtigheden afhænger af punkttætheden (punkter pr. m2) i det valgte oktræ-niveau, ikke af oktræets "punktafstand". Målt mod
// Pythons fuld-opløsnings-resultater på tre rigtige skyer (WORKLOG): ved >= ca. 1000 punkter/m2 ligger udgravningen inden for ca.
// 2 % (de to små skyer allerede ved 30-500 tusinde punkter, den store sky 1,7 % ved 8,4 mio.); ved ca. 700 punkter/m2 ca. 10 %, ved
// ca. 200 punkter/m2 40 % og derover. Derfor: det FØRSTE niveau med tæthed >= targetDensity, men aldrig mere end punktbudgettet.
// under denne tæthed ligger afvigelsen fra fuld opløsning på 10 % eller mere (målt): der vises en advarsel
export const LOW_DENSITY = 700;

export const JOB_DEFAULTS = {
	cell: 0.3,
	minDepth: 0.03,
	maxPoints: 9000000,       // ca. 300 MB, der hentes fra serveren, i det største tilfælde
	maxLevel: 10,             // dybeste niveau, hierarkiet indekseres til
	targetDensity: 1500,      // punkter pr. m2 (ca. 130 pr. 0,3 m celle)
	// på grove niveauer er kun få punkter pr. celle jord: ét punkt er nok som kontrolpunkt (afviser-filteret renser dem)
	minPoints: 3,
	minGroundPoints: 1,
};

// Vælger niveauet ud fra de indekserede noder. nodes: [{level, numPoints, area, leaf}] hvor `area` er nodens udstrækning i planen
// (m2) og `leaf` om den ikke har børn. Fladen på et niveau = noder på niveauet + blade på højere niveauer (de dækker områder,
// der ikke forfines); lodret stablede noder tælles med, så fladen overvurderes en smule og niveauet vælges lidt finere end nødvendigt.
export function planLevel(nodes, {cell, maxPoints, maxLevel, targetDensity}){
	const perLevel = [];
	const areaAt = [];
	const leafAreaAt = [];
	for(const node of nodes){
		const level = node.level || 0;
		perLevel[level] = (perLevel[level] || 0) + (node.numPoints || 0);
		areaAt[level] = (areaAt[level] || 0) + (node.area || 0);
		if(node.leaf) leafAreaAt[level] = (leafAreaAt[level] || 0) + (node.area || 0);
	}
	const deepest = Math.max(0, Math.min(perLevel.length - 1, maxLevel));

	const cumulative = [];
	const footprint = [];
	let points = 0, leafArea = 0;
	for(let l = 0; l <= deepest; l++){
		points += perLevel[l] || 0;
		cumulative[l] = points;
		// blade på LAVERE niveauer dækker stadig området, men tæller ikke dobbelt, når niveauet selv har noder dér
		footprint[l] = (areaAt[l] || 0) + leafArea;
		leafArea += leafAreaAt[l] || 0;
	}
	const densityAt = (l) => (footprint[l] > 0 ? cumulative[l] / footprint[l] : Infinity);

	// første niveau med nok tæthed (ellers det dybeste)
	let level = deepest;
	for(let l = 0; l <= deepest; l++){
		if(densityAt(l) >= targetDensity){ level = l; break; }
	}
	let budgetLimited = false;
	while(level > 0 && cumulative[level] > maxPoints){ level--; budgetLimited = true; }

	const density = densityAt(level);
	const finite = Number.isFinite(density) && density > 0;
	return {
		level,
		deepestIndexed: deepest,
		points: cumulative[level],
		density: finite ? density : 0,
		reachedTarget: density >= targetDensity,
		lowDensity: !(density >= LOW_DENSITY),
		// en tyndere sky får en større celle, så en celle stadig har ca. 12 punkter
		cell: Math.max(cell, finite ? Math.sqrt(12 / density) : cell),
		budgetLimited,
	};
}
